import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_PERSON = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        aliases {
          id
          target {
            id
            validPersonAlerts {
              alertType {
                name
                alertLevel
              }
            }
          }
        }
        id
        uuid
        genericAttachments {
          attachmentType {
            id
            name
            oriId
            position
          }
          incident {
            id
            ori {
              id
            }
          }
          confidential
          dataUrl
          dataUrlWrapper
          description
          id
        }
        groups {
          id
          name
          oriId
          position
        }
        validPersonAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          officerId
          createdAt
          officer {
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
          person {
            id
          }
        }
        personalAttribute {
          aliasName
          bilingual
          buildType {
            id
            name
            oriId
            position
          }
          cell
          deceased
          distinguishingCharacteristics
          dob
          driversLicense
          email
          employer
          employerAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
              id
              notes
            }
            zip
          }
          eyeColor {
            id
            name
            oriId
            position
          }
          facialHairType {
            id
            name
            oriId
            position
          }
          fbiNumber
          firstName
          fishWildlifeLicense
          gangAffiliateds {
            id
            name
            oriId
            position
          }
          gender {
            id
            name
            oriId
            position
          }
          hairColor {
            id
            name
            oriId
            position
          }
          hairLength {
            id
            name
            oriId
            position
          }
          height
          homeAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
              id
              notes
            }
            zip
          }
          ibrArresteeRaceType {
            id
            name
            oriId
            position
          }
          id
          juvenile
          lastName
          licenseState {
            id
            name
            oriId
            position
          }
          mailingAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
              id
              notes
            }
            zip
          }
          mentalHealthAlert
          middleName
          nibrsGender {
            id
            name
            oriId
            position
          }
          notes
          oldNames
          oldPhones
          organization
          phone
          pobAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
              id
              notes
            }
            zip
          }
          race {
            id
            name
            oriId
            position
          }
          residentType {
            id
            name
            oriId
            position
          }
          sid
          substanceAbuseAlert
          suffix
          uuid
          violenceAlert
          waiverFine
          weaponsAlert
          weight
          work
        }
        photos {
          attachmentType {
            id
            name
            oriId
            position
          }
          confidential
          dataUrl
          dataUrlWrapper
          description
          id
        }
      }
      errors
    }
  }
`;
